<div class="container-fluid bg-white layout-wrapper">
  <div class="row">
    <!-- Sidebar -->
    <div class="col-auto p-0">
      <app-side-nav></app-side-nav>
    </div>

    <!-- Main Content -->
    <div class="col px-3 mt-3">
      <!-- Page Heading -->
      <div class="container px-0">
        <div class="row align-items-center mb-4">
          <div class="col-6">
            <h4 class="study-heading">
              <span class="text-muted fw-light">Data Management /</span> Query
              View
            </h4>
          </div>
        </div>
      </div>

      <!-- Study Selection Section -->
      <div class="container px-0 mb-4">
        <div class="row gy-3 align-items-end">
          <!-- Make study-name dropdown use almost full width, leaving minimal space for the button -->
          <div class="col-12 col-md-9 col-lg-10">
            <label class="form-label fw-bold">Select Study Name</label>
            <div
              class="custom-dropdown-container"
              [class.active]="isStudyDropdownOpen"
            >
              <div
                class="custom-dropdown-trigger"
                (click)="toggleStudyDropdown()"
                [class.active]="isStudyDropdownOpen"
              >
                <span *ngIf="!selectedStudyName" class="dropdown-placeholder">
                  Select study name
                </span>
                <span *ngIf="selectedStudyName">{{ selectedStudyName }}</span>
                <i class="bx bx-chevron-down dropdown-arrow"></i>
              </div>
              <div class="custom-dropdown-list" *ngIf="isStudyDropdownOpen">
                <div class="dropdown-header">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Search studies..."
                    [(ngModel)]="studySearchText"
                    (input)="filterStudies()"
                  />
                </div>
                <div class="dropdown-items">
                  <div
                    class="dropdown-item-custom"
                    *ngFor="let study of filteredStudies"
                    [class.selected]="
                      selectedStudyId === (study.id || study.study_id)
                    "
                    (click)="selectStudy(study)"
                  >
                    <div class="study-item">
                      <div class="study-info">
                        <div class="study-name">
                          {{ study.name || study.study_name }}
                        </div>
                      </div>
                      <i
                        class="bx bx-check"
                        *ngIf="selectedStudyId === (study.id || study.study_id)"
                      ></i>
                    </div>
                  </div>
                  <div
                    class="dropdown-item-custom text-center text-muted"
                    *ngIf="filteredStudies.length === 0"
                  >
                    No studies found
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-3 col-lg-2">
            <button
              class="btn custom-button w-100"
              (click)="submitStudySelection()"
              [disabled]="!selectedStudyId"
            >
              Submit
            </button>
          </div>
        </div>
      </div>

      <!-- Instruction -->
      <p class="instruction-text">
        Click on <strong>Query ID</strong> to open form in Study.
      </p>

      <!-- Tabs: All / Open / Answered / Closed + Total Query Count -->
      <div
        class="d-flex justify-content-between align-items-center mb-3"
        *ngIf="data.length > 0"
      >
        <ul class="nav nav-pills">
          <li class="nav-item">
            <button
              class="nav-link"
              [class.active]="activeTab === 'all'"
              type="button"
              (click)="setActiveTab('all')"
            >
              All
            </button>
          </li>
          <li class="nav-item">
            <button
              class="nav-link"
              [class.active]="activeTab === 'open'"
              type="button"
              (click)="setActiveTab('open')"
            >
              Open
            </button>
          </li>
          <li class="nav-item">
            <button
              class="nav-link"
              [class.active]="activeTab === 'answered'"
              type="button"
              (click)="setActiveTab('answered')"
            >
              Answered
            </button>
          </li>
          <li class="nav-item">
            <button
              class="nav-link"
              [class.active]="activeTab === 'closed'"
              type="button"
              (click)="setActiveTab('closed')"
            >
              Closed
            </button>
          </li>
        </ul>
        <div class="total-query-count-badge">
          Total Query Count: {{ data.length }}
        </div>
      </div>

      <!-- Filters (shown when data is loaded) - same as Data View -->
      <div
        *ngIf="data.length > 0"
        class="filter-row d-flex flex-wrap gap-2 mb-3 mt-2 align-items-center"
      >
        <div class="flex-grow-1" style="width: 180px">
          <select
            [(ngModel)]="queryIdFilter"
            class="form-select cursor-pointer"
          >
            <option value="" disabled selected hidden>
              Filter By Query ID
            </option>
            <option value="">All Query IDs</option>
            <option
              *ngFor="let queryId of availableQueryIds"
              [value]="queryId"
            >
              {{ queryId }}
            </option>
          </select>
        </div>

        <div class="flex-grow-1" style="width: 180px">
          <select
            [(ngModel)]="participantFilter"
            class="form-select cursor-pointer"
          >
            <option value="" disabled selected hidden>Filter By Participant</option>
            <option value="">All Participants</option>
            <option *ngFor="let participant of availableParticipants" [value]="participant">
              {{ participant }}
            </option>
          </select>
        </div>
        <div class="flex-grow-1" style="width: 180px">
          <small class="text-muted d-block mb-1">Start Date (Query Opened)</small>
          <input
            type="date"
            class="form-control cursor-pointer"
            [(ngModel)]="startDateFilter"
          />
        </div>
        <div class="flex-grow-1" style="width: 180px">
          <small class="text-muted d-block mb-1">End Date (Query Opened)</small>
          <input
            type="date"
            class="form-control cursor-pointer"
            [(ngModel)]="endDateFilter"
          />
        </div>

        <div class="d-flex gap-2 flex-wrap">
          <button class="btn custom-button" (click)="applyFilters()">Search</button>
          <button
            class="btn custom-button"
            (click)="downloadCSV()"
            [disabled]="!selectedStudyId || loading || isExportingCSV"
          >
            <i class="bx bx-download me-1" *ngIf="!isExportingCSV"></i>
            <span
              class="spinner-border spinner-border-sm me-1"
              *ngIf="isExportingCSV"
              role="status"
            ></span>
            {{ isExportingCSV ? 'Generating...' : 'Download CSV' }}
          </button>
          <button class="btn custom-button" (click)="clearFilters()">
            Clear
          </button>
        </div>
      </div>

      <!-- Loader -->
      <div
        *ngIf="loading"
        class="d-flex justify-content-center align-items-center"
        style="height: 150px"
      >
        <div class="spinner-border text-purple"></div>
      </div>

      <!-- Table Section -->
      <div class="card" *ngIf="!loading && paginatedData.length > 0">
        <div class="table-responsive rounded query-table-wrapper">
          <table class="table table-hover query-view-table">
            <thead>
              <tr>
                <th class="text-nowrap">Query ID</th>
                <th class="text-nowrap">Study ID</th>
                <th class="text-nowrap">Participant ID</th>
                <th class="text-nowrap">Site Location</th>
                <th class="text-nowrap">Query Open</th>
                <th class="text-nowrap">Query Opened Date</th>
                <th class="text-nowrap">Query Age</th>
                <th class="text-nowrap">Query Opened By &amp; Role</th>
                <th class="text-nowrap">Query Response</th>
                <th class="text-nowrap">Query Response Date</th>
                <th class="text-nowrap">Response By &amp; Role</th>
                <th class="text-nowrap">Closed By &amp; Role</th>
                <th
                  class="text-nowrap"
                  *ngIf="isMonitor && activeTab === 'open'"
                >
                  Select
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of paginatedData">
                <td>
                  <span
                    class="query-id-link cursor-pointer"
                    (click)="openQueryModal(row)"
                  >
                    {{ row.unique_query_id || '-' }}
                  </span>
                </td>
                <td>{{ row.study_id }}</td>
                <td>{{ row.subject_id }}</td>
                <td>{{ row.site_location || '—' }}</td>
                <td>{{ row.query_open || '—' }}</td>
                <td>{{ row.query_opened_date ? (row.query_opened_date | date:'medium') : '—' }}</td>
                <td>{{ getQueryAge(row.query_opened_date) }}</td>
                <td>{{ row.opened_by_role || '—' }}</td>
                <td>{{ row.query_response ?? '—' }}</td>
                <td>{{ row.query_response_date ? (row.query_response_date | date:'medium') : '—' }}</td>
                <td>{{ row.response_by_role || '—' }}</td>
                <td>{{ row.closed_by_role || '—' }}</td>
                <td *ngIf="isMonitor && activeTab === 'open'">
                  <input
                    type="checkbox"
                    [checked]="isQuerySelected(row)"
                    (change)="toggleQuerySelection(row, $event.target.checked)"
                  />
                </td>
                <!-- <td>
                  <button
                    class="btn btn-sm custom-button"
                    (click)="openQueryModal(row)"
                  >
                    <i class="bx bx-link-external me-1"></i> Open Query
                  </button>
                </td> -->
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Bulk close footer -->
        <div
          class="card-footer d-flex justify-content-between align-items-center"
          *ngIf="isMonitor && activeTab === 'open'"
        >
          <div class="text-muted">
            {{ selectedQueryIds.size }} query{{ selectedQueryIds.size === 1 ? '' : 'ies' }} selected
          </div>
          <button
            class="btn btn-danger"
            [disabled]="selectedQueryIds.size === 0 || isBulkClosing"
            (click)="closeSelectedQueries()"
          >
            <span
              class="spinner-border spinner-border-sm me-1"
              *ngIf="isBulkClosing"
              role="status"
            ></span>
            {{ isBulkClosing ? 'Closing...' : 'Close Selected Queries' }}
          </button>
        </div>
      </div>

      <!-- No Data Message -->
      <div
        class="text-center text-muted py-5"
        *ngIf="!loading && paginatedData.length === 0 && selectedStudyId"
      >
        {{ data.length === 0 ? 'No queries found for the selected study.' : 'No results match the current filters.' }}
      </div>

      <!-- Pagination -->
      <div
        class="d-flex justify-content-center mt-4 mb-5"
        *ngIf="totalUsers > 0"
      >
        <nav>
          <ul class="pagination cursor-pointer">
            <li class="page-item" [class.disabled]="currentPage === 1">
              <a class="page-link" (click)="prevPage()">Previous</a>
            </li>
            <li
              class="page-item mx-1"
              *ngFor="let page of pageRange"
              [class.active]="page === currentPage"
            >
              <a class="page-link" (click)="goToPage(page)">{{ page }}</a>
            </li>
            <li class="page-item" [class.disabled]="currentPage === pages">
              <a class="page-link" (click)="nextPage()">Next</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</div>
